export default __webpack_public_path__ + "static/media/reflive.9cc12495.svg";